function creditCardFormatInput(value) {
    value = value || '';
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    var matches = v.match(/\d{4,18}/g);
    var match = matches && matches[0] || '';
    var parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
        return parts.join(' ');
    } else {
        return value;
    }
}

function numbersAndSpaces(val) {
    return /^(?=.*\d)[\d ]+$/.test(val);
}

export {
    creditCardFormatInput,
    numbersAndSpaces
}
